import { render, staticRenderFns } from "./ImportTaskCard.vue?vue&type=template&id=f4b00d80&scoped=true"
import script from "./ImportTaskCard.vue?vue&type=script&lang=js"
export * from "./ImportTaskCard.vue?vue&type=script&lang=js"
import style0 from "./ImportTaskCard.vue?vue&type=style&index=0&id=f4b00d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b00d80",
  null
  
)

export default component.exports